<template>
  <div class="progress-bar">
    <div class="progress-bar-text">{{text}}</div>
    <h3 class="progress-bar-title">{{width}}</h3>
    <div class="bar">
      <div class="color-bar" :style="'background-color:'+ color + ';width: ' + width"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProgressBar',
    props: {
      color: String,
      width: String,
      text: String
    },
    data() {
      return {

      }
    },
    mounted() {
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/progress_bar.sass"
</style>
